/**
 * URL assoluto di una foto profilo (associati e rappresentanti).
 *
 * Il backend salva un percorso RELATIVO (`/uploads/associate-photos/...`,
 * `/uploads/representative-photos/...`) e serve i file statici SENZA il
 * prefisso `/api`: la base giusta e quindi
 * `REACT_APP_API_BASE_URL` privata del SUFFISSO `/api` — stesso indirizzo usato
 * da `AssociateDashboardPage.tsx` e `SupportTicketDetailPage.tsx`. Si taglia la
 * coda, non la prima occorrenza: un host che contiene `/api` nel percorso (es.
 * `https://x.it/api-gw/api`) resterebbe altrimenti mutilato.
 *
 * Ritorna `undefined` quando non c'e foto: chi chiama mostra le iniziali.
 * Un valore gia assoluto (http/https o `data:`) viene lasciato com'e.
 */
export const FILES_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');

export function photoUrl(rel?: string | null): string | undefined {
  const p = (rel || '').trim();
  if (!p) return undefined;
  if (/^(https?:)?\/\//i.test(p) || p.startsWith('data:')) return p;
  return `${FILES_BASE}${p.startsWith('/') ? '' : '/'}${p}`;
}


/**
 * URL dell'avatar di un utente amministrativo: foto caricata (percorso
 * relativo) o, per i profili storici, il vecchio `profilePicture`.
 * `undefined` -> chi chiama mostra le iniziali.
 */
export function avatarSrc(u?: { profile?: { foto?: string | null; profilePicture?: string | null } | null }): string | undefined {
  return photoUrl(u?.profile?.foto) || u?.profile?.profilePicture || undefined;
}

export default photoUrl;
